import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { startLoading, stopLoading } from '../../../slices/loading.slice';
import { closeModal } from '../../../slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { postProductApplicationDropdown } from '../../../slices/productcostapplication.slice';
import { updatedProductServiceGrid } from '../../../slices/serviceagreements.slice';
import '../delete-conformation-modal/delete-conformation-modal.scss'

const SaveModuleModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const { selectedApproveRecord,menuName,currentaddedData } = useAppSelector((state) => state.applicationdropdown);
  useEffect(() => {
    dispatch(stopLoading());
  }, [dispatch]);
  const handleCancel = () => {
    dispatch(closeModal());
  };
  const handleSave = () => {
    if (!currentaddedData) {
      toast.error("Invalid item selected");
      return;
    }
    dispatch(startLoading());
    if(menuName === 'ServiceAgreements')
    {
      dispatch(updatedProductServiceGrid(selectedApproveRecord))
      .unwrap()
    }
    else{
        const handlePostProductApplication = async () => {
            try {
                const result = await dispatch(postProductApplicationDropdown(currentaddedData)).unwrap();
                // dispatch(closeModal());
                if (result.message.includes('Record Added Successfully')) {
                    toast.success(result.message);
                } else {
                    toast.error(result.message);
                }
            } catch (error) {
                console.error('Approve failed:', error);
                toast.error("Failed to approve item");
            } finally {
                dispatch(stopLoading());
            }
        };
        
        handlePostProductApplication();
       
    }
  };
  return (
    <div className='modal-container'>
      <div>
        <p>Are you sure want to save the record?</p>
      </div>
      <div className='buttonContainer'>
            <button className='cancelButton' onClick={handleCancel}>Cancel</button>
            <button className='saveButton' onClick={handleSave} >save</button>
          </div>
    </div>
  );
};
export default SaveModuleModal;